import { JsonPipe, DecimalPipe } from "@angular/common";
import { Component, OnInit, Input, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgbPagination } from "@ng-bootstrap/ng-bootstrap/pagination";

import { ApiService } from "src/app/api.service";
import { FilesizePipe, HttpstatuscolorPipe, DatetimePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-mech-log",
	templateUrl: "./mech-log.component.html",
	styleUrls: ["./mech-log.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgbPagination, FormsModule, JsonPipe, DecimalPipe, FilesizePipe, HttpstatuscolorPipe, DatetimePipe]
})
export class MechLogComponent implements OnInit {
	private modalService = inject(NgbModal);
	api = inject(ApiService);

	@ViewChild("exceptionModal", { static: true }) public exceptionModal: any;

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;

	public brand = BrandVars;

	public totalLogs = 0;
	public currentPage = 1;
	public itemsPerPage = 30;
	public pageLogs: any[] = undefined;
	public pageLoading = false;
	public selectedException: any = null;
	public selectedExceptionStack?: string = undefined;
	public selectedExceptionSubStack?: string = undefined;
	public filters: any = {};

	async ngOnInit() {
		this.ResetFilters();
	}

	async updatePage() {
		try {
			this.pageLoading = true;
			const result = await this.api.GetAssetSystemLog(this.asset.asset_id, this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage,
				this.filters.remote_ip, this.filters.status_code, this.filters.http_method, this.filters.path,
				this.filters.only_exceptions, this.filters.only_errors);
			this.totalLogs = result.count;
			this.pageLogs = result.rows;
		} finally {
			this.pageLoading = false;
		}
	}

	refreshTable() {
		this.currentPage = 1;
		this.pageLogs = undefined;
		this.updatePage();
	}

	showException(log: any) {
		try {
			this.selectedExceptionStack = undefined;
			this.selectedException = JSON.parse(log.exception);
			if (this.selectedException.stack) {
				this.selectedExceptionStack = this.selectedException.stack;
				delete this.selectedException.stack;
			}
			if (this.selectedException.detail && this.selectedException.detail.StackTrace) {
				this.selectedExceptionSubStack = this.selectedException.detail.StackTrace;
				delete this.selectedException.detail.StackTrace;
			}
		} catch {
			this.selectedException = log.exception;
		}
		this.modalService.open(this.exceptionModal, { size: "lg" });
	}

	applyFilter(field: string, value: any) {
		this.filters[field] = value;
		this.refreshTable();
	}

	removeFilter(field: string) {
		this.filters[field] = null;
		this.refreshTable();
	}

	ResetFilters() {
		this.filters = {
			only_errors: false,
		};
		this.refreshTable();
	}
}
